import HoleDimension from "./HoleDimension";

export default HoleDimension;